import { render, staticRenderFns } from "./AdministradorTab.vue?vue&type=template&id=340ce46c"
import script from "./AdministradorTab.vue?vue&type=script&lang=js"
export * from "./AdministradorTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports